import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const Closing: React.FC = () => {
  return <section className="py-24 px-6 bg-cream-dark relative" data-id="element-17">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 flex space-x-3 mt-[-3px]" data-id="element-18">
        <div className="w-1.5 h-1.5 rounded-full bg-rose" data-id="element-19"></div>
        <div className="w-1.5 h-1.5 rounded-full bg-rose" data-id="element-20"></div>
        <div className="w-1.5 h-1.5 rounded-full bg-rose" data-id="element-21"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-10" data-id="element-23">
          <p className="text-xl md:text-2xl text-charcoal font-light leading-relaxed" data-id="element-24">
            Tú ya aprendiste a estar sola. Ya aprendiste que no necesitas a
            nadie para ser feliz. Ahora, es momento de aprender a elegir a
            alguien que multiplique esa felicidad, que respete tu libertad y que
            camine a tu lado sin querer frenarte.
          </p>

          <p className="text-lg text-charcoal-light font-light leading-relaxed" data-id="element-25">
            No te conformes con migajas emocionales solo porque "así es el amor
            ahora". El amor que suma, que respeta y que admira tu fuerza existe.
            Solo tienes que aprender a reconocerlo.
          </p>

          <div className="pt-8 pb-4" data-id="element-26">
            <Button className="w-full md:w-auto text-sm md:text-base py-4 px-6 md:py-5 md:px-10" onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-27">
              Descarga tu copia de "El Hombre Ideal para una Mujer
              Independiente"
            </Button>
          </div>

          <div className="relative py-8" data-id="element-28">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-16 h-px bg-gold" data-id="element-29"></div>
            <p className="text-2xl md:text-3xl font-serif text-black italic leading-relaxed" data-id="element-30">
              "Es hora de que dejes de ser la que siempre sostiene todo, y
              empieces a elegir a quien sepa sostenerte a ti también."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};